import { render, staticRenderFns } from "./Diameter-Graph.vue?vue&type=template&id=567dfb0a&scoped=true"
import script from "./Diameter-Graph.vue?vue&type=script&lang=js"
export * from "./Diameter-Graph.vue?vue&type=script&lang=js"
import style0 from "./Diameter-Graph.vue?vue&type=style&index=0&id=567dfb0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567dfb0a",
  null
  
)

export default component.exports